<template>
  <div class="ticket-status">
    <span :class="statuses[status].class">
      {{ statuses[status].display }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
    statuses:{
      type: Object,
      required: true,
    }
  },
}
</script>

<style lang="scss" scoped>
.ticket-status {
  display: flex;
  justify-content: center;

  .danger {
    color: #d47777;
  }

  .warning {
    color: #ffc107;
  }

  .success {
    color: #6cc58c
  }

  .primary {
    color: #8260ac;
  }

  .secondary {
    color: #6c757d;
  }
}
</style>
